var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"fade"}},[(_vm.isShow)?_c('div',{staticClass:"fixed right-4 bottom-4"},[_c('div',{staticClass:"toTop-arrow",on:{"click":_vm.scrollTop}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }